import { Box } from "@mui/material";
import { BreadcrumbItem, Breadcrumbs } from "@vds/breadcrumbs";
import { Button } from "@vds/buttons";
import { useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import BulkRuleTable from "../../global/components/Tables/BulkRuleTable";
import SearchInput from "../../global/utility/Utils";
import NotificationBanner from "../../layouts/NotificationBanner";
import { fetchRules } from "../../model/ruleService";
import "./bulkrule.css";
import { CREATERULE_TEST_IDS } from "./CreateRule/createRuleConstants";

const BulkRule = () => {
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );

  const [searchValue, setSearchValue] = useState("");
  const navigate = useNavigate();
  const [showNotification, setShowNotification] = useState(false);

  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
  };

  const createBulkRule = () => {
    navigate("/createBulkRule");
  };

  const tableData = [
    {
      name: "Parking lot occupancy",
      app: "Parking occupancy",
      site: "Middle school",
      floor: "Floor 1",
      area: "Parking Area A",
      camera: "Camera 1",
      roi: "2 Regions of interest",
      condition: "Parking availability less than 20%",
    },
    {
      name: "Name 2",
      app: "Count",
      site: "Middle school",
      floor: "Floor 2",
      area: "Area B",
      camera: "Camera 2",
      roi: "4 Regions of interest",
      condition: "Condition",
    },
  ];

  const getRules = async () => {
    try {
      const resp = await fetchRules(activeSession);
      console.log(resp, "All rules fetch");
    } catch (error) {
      console.log("Getting error", error);
    }
  };

  const filteredData = tableData?.filter((item) => {
    return (
      item?.name.toLowerCase().includes(searchValue.toLowerCase()) ||
      item?.app.toLowerCase().includes(searchValue.toLowerCase()) ||
      item?.site.toLowerCase().includes(searchValue.toLowerCase()) ||
      item?.floor.toLowerCase().includes(searchValue.toLowerCase()) ||
      item?.area.toLowerCase().includes(searchValue.toLowerCase()) ||
      item?.camera.toLowerCase().includes(searchValue.toLowerCase()) ||
      item?.roi.toLowerCase().includes(searchValue.toLowerCase()) ||
      item?.condition.toLowerCase().includes(searchValue.toLowerCase())
    );
  });

  return (
    <>
      {showNotification && (
        <div
          style={{
            position: "fixed",
            top: 0,
            zIndex: 1050,
          }}
        >
          <NotificationBanner
            notificationInfo={{
              type: "No Permission",
              priority: "critical",
            }}
            setShowNotification={setShowNotification}
          />
        </div>
      )}
      <Breadcrumbs surface="light">
        <BreadcrumbItem>
          <Link
            data-testid="bulkRule_settingsLink"
            to="/settings"
            className="breadcrums-item_link"
          >
            Settings
          </Link>
        </BreadcrumbItem>
        <BreadcrumbItem>Rules</BreadcrumbItem>
      </Breadcrumbs>
      <div className="rule-heading">Rules</div>

      <Box sx={{ pt: 2, pb: 2, width: "100%" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            height: "44px",
            gap: "0px",
            justify: "space-between",
            opacity: "0px",
          }}
        >
          <SearchInput
            onChange={handleSearchChange}
            data-testid={CREATERULE_TEST_IDS.BULK_RULE_SEARCH_INPUT}
            value={searchValue}
            placeholder="Search"
          />
          <Button
            size="medium"
            surface="light"
            disabled={false}
            use="primary"
            onClick={() => {
              createBulkRule();
              getRules();
            }}
            data-testid={CREATERULE_TEST_IDS.BULK_RULE_CREATE_BUTTON}
          >
            Create Rule
          </Button>
        </div>
      </Box>
      {console.log(
        Array.isArray(filteredData),
        "Checking before Filtered data",
        filteredData
      )}
      <BulkRuleTable data={filteredData} />
    </>
  );
};

export default BulkRule;
